import { ref, get } from 'firebase/database';
import { database } from '../firebase';

export interface HighSchoolLocation {
  latitude: number;
  longitude: number;
}

/**
 * Fetch the location data for a high school by its ID
 * @param schoolID The high school ID
 * @returns Promise with latitude and longitude, or null if not found
 */
export async function getHighSchoolLocation(schoolID: string): Promise<HighSchoolLocation | null> {
  try {
    const highSchoolRef = ref(database, `highSchools/${schoolID}`);
    const snapshot = await get(highSchoolRef);
    
    if (snapshot.exists()) {
      const data = snapshot.val();
      
      const latitude = parseFloat(data.HighSchoolLocationLatitude);
      const longitude = parseFloat(data.HighSchoolLocationLongitude);
      
      if (!isNaN(latitude) && !isNaN(longitude)) {
        return { latitude, longitude };
      }
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching high school location:', error);
    return null;
  }
}

/**
 * Fetch the location data for a high school by its name
 * @param schoolName The high school name
 * @returns Promise with latitude and longitude, or null if not found
 */
export async function getHighSchoolLocationByName(schoolName: string): Promise<HighSchoolLocation | null> {
  try {
    const highSchoolsRef = ref(database, 'highSchools');
    const snapshot = await get(highSchoolsRef);
    
    if (snapshot.exists()) {
      const schoolsData = snapshot.val();
      
      // Find the school by name
      for (const [id, data] of Object.entries(schoolsData)) {
        const schoolData = data as any;
        if (schoolData.HighSchoolName === schoolName) {
          const latitude = parseFloat(schoolData.HighSchoolLocationLatitude);
          const longitude = parseFloat(schoolData.HighSchoolLocationLongitude);
          
          if (!isNaN(latitude) && !isNaN(longitude)) {
            return { latitude, longitude };
          }
        }
      }
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching high school location by name:', error);
    return null;
  }
}
